export { ImageSVG } from './ImageSVG';
export type { ImageNameType } from './ImageSVG';
